import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: 'DashboardSummaryForAgents',

  props: {
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    copiedAgentsList() {
      return hDeepCopy(this.agentList);
    },
    allAgentsCount() {
      return this.copiedAgentsList.length;
    },
    loggedAgentsCount() {
      return this.copiedAgentsList.filter(agent => agent.is_logged).length;
    },
    talkingAgentsCount() {
      return this.copiedAgentsList.filter(agent => agent.is_talking).length;
    },
    onBreakAgentsCount() {
      return this.copiedAgentsList.filter(agent => agent.is_paused).length;
    },
    onDndAgentsCount() {
      return this.copiedAgentsList.filter(agent => agent.is_dnd).length;
    },
    availableAgentsCount() {
      return this.copiedAgentsList.filter(agent => agent.is_logged && !agent.is_paused && !agent.is_dnd && !agent.is_talking).length;
    },

  },
};
